import { getRestaurantDate, getRestaurantWeekday } from '@/utils/date';

export const HOURS = [
  {
    dayOfWeek: 'Monday',
    timeRanges: ['4:00 PM - 9:00 PM'],
  },
  {
    dayOfWeek: 'Tuesday',
    timeRanges: ['4:00 PM - 9:00 PM'],
  },
  {
    dayOfWeek: 'Wednesday',
    timeRanges: ['12:00 PM - 2:30 PM', '4:00 PM - 9:00 PM'],
  },
  {
    dayOfWeek: 'Thursday',
    timeRanges: ['11:30 AM - 9:00 PM'],
  },
  {
    dayOfWeek: 'Friday',
    timeRanges: ['11:30 AM - 9:30 PM'],
  },
  {
    dayOfWeek: 'Saturday',
    timeRanges: ['11:30 AM - 10:00 PM'],
  },
  {
    dayOfWeek: 'Sunday',
    timeRanges: ['12:00 PM - 9:00 PM'],
  },
];

export interface SpecialHours {
  date: string; // "YYYY-MM-DD", Pickering time
  label: string;
  timeRanges: string[]; // empty = closed
}

// Holiday / one-off hours. They replace the regular hours on that date; past dates are ignored.
// Also set them on the Google Business Profile, which most people see first.
export const SPECIAL_HOURS: SpecialHours[] = [
  { date: '2026-10-12', label: 'Thanksgiving', timeRanges: ['4:00 PM - 9:00 PM'] },
];

const DAY_MS = 24 * 60 * 60 * 1000;

// Today's opening times in Pickering, with the holiday's name when it's a special day
export const getTodaysHours = (date = new Date()) => {
  const special = SPECIAL_HOURS.find((day) => day.date === getRestaurantDate(date));
  if (special) {
    return { label: special.label, timeRanges: special.timeRanges };
  }
  const regular = HOURS.find(({ dayOfWeek }) => dayOfWeek === getRestaurantWeekday(date));
  return { label: null, timeRanges: regular?.timeRanges ?? [] };
};

// Special days from today through the next `days` days
export const getUpcomingSpecialHours = (date = new Date(), days = 30) => {
  const today = getRestaurantDate(date);
  const lastDay = getRestaurantDate(new Date(date.getTime() + days * DAY_MS));
  return SPECIAL_HOURS.filter((day) => day.date >= today && day.date <= lastDay);
};
